fragment downtimeReasonInfo on DowntimeReason {
  id
  reason
  code
}
